import { render, staticRenderFns } from "./LockConfig.vue?vue&type=template&id=6f09104a&"
import script from "./LockConfig.vue?vue&type=script&lang=js&"
export * from "./LockConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports